import * as Tone from 'tone';
import AudioEffect from './AudioEffect';
class AutoFilter extends AudioEffect {
    constructor() {
        super(...arguments);
        this.filter = new Tone.Filter();
    }
    input() { return this.filter; }
    output() { return this.filter; }
    get frequency() {
        return this.filter.frequency;
    }
    get Q() {
        return this.filter.Q;
    }
    get type() {
        return this.filter.type;
    }
    set type(type) {
        this.filter.type = type;
    }
}
export default AutoFilter;
//# sourceMappingURL=AutoFilter.js.map